import { useState } from "react";
import { useNavigate } from "react-router-dom";

// Dummy data for groups
interface DummyGroup {
  id: number;
  name: string;
  members: number;
  location: string;
  image: string;
  joined: boolean;
}

const dummyGroups: DummyGroup[] = [
  {
    id: 1,
    name: "Nhận nuôi thú cưng",
    members: 2000,
    location: "Hà Nội",
    image: "/images/thucung.png",
    joined: false,
  },
  {
    id: 2,
    name: "Hội trồng cây",
    members: 2000,
    location: "Hà Nội",
    image: "/images/trongcay.png",
    joined: false,
  },
  {
    id: 3,
    name: "Hội pass đồ uy tín",
    members: 2000,
    location: "Hà Nội",
    image: "/images/passdo.png",
    joined: false,
  },
  {
    id: 4,
    name: "Tìm việc làm",
    members: 2000,
    location: "Hà Nội",
    image: "/images/vieclam.png",
    joined: false,
  },
];

export default function GroupsPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch all groups - temporarily disabled
  // const { data: groupsData, isLoading } = useQuery({
  //   queryKey: ["groups", "all", { search: debouncedSearch }],
  //   queryFn: () => groupsApi.getGroups({
  //     search: debouncedSearch
  //   }),
  // });

  const groupsData: { results: DummyGroup[] } | null = null;
  const isLoading = false;

  const handleGroupClick = (groupId: number) => {
    const group = dummyGroups.find((g) => g.id === groupId);
    if (group) {
      const groupData = {
        id: group.id.toString(),
        name: group.name,
        description: `Chào mừng bạn đến với ${group.name}`,
        location: group.location,
        memberCount: group.members,
        avatar: group.image,
        coverImage: "https://placehold.co/343x152",
      };
      navigate("/group-detail", { state: { group: groupData } });
    }
  };

  const handleJoinToggle = async (groupId: number, joined: boolean) => {
    // Temporarily disabled
    console.log("Join toggle:", groupId, joined);
    // try {
    //   if (joined) {
    //     await groupsApi.leaveGroup(groupId);
    //   } else {
    //     await groupsApi.joinGroup(groupId);
    //   }
    // } catch (error) {
    //   console.error("Error toggling group join status:", error);
    // }
  };

  const handleCreateGroup = () => {
    console.log("Create group clicked");
  };

  // Use dummy data if API data is not available
  const groups: DummyGroup[] =
    (groupsData as { results: DummyGroup[] } | null)?.results || dummyGroups;

  return (
    <div className="w-full h-full bg-[#FBF6F1] flex flex-col">
      {/* Header */}
      <div className="w-full h-14 p-4 inline-flex justify-between items-center">
        <div
          className="size-7 relative overflow-hidden"
          onClick={() => navigate(-1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M17.5 7L10.5 14L17.5 21"
              stroke="#1E3A3A"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="justify-start text-[#1E3A3A] text-2xl font-medium font-manrope leading-7">
          Hội nhóm
        </div>
        <div
          className="size-7 relative overflow-hidden"
          onClick={handleCreateGroup}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M16.7569 6.59367L18.4835 4.86701C19.3947 3.95579 20.8721 3.95579 21.7834 4.86701L23.4333 6.51694C24.3444 7.42815 24.3444 8.90553 23.4333 9.81676L21.7066 11.5434M16.7569 6.59367L5.53858 17.8119C5.15117 18.1994 4.91243 18.7107 4.86422 19.2565L4.58179 22.4537C4.51789 23.1771 5.12324 23.7824 5.84659 23.7185L9.04374 23.4361C9.58952 23.3879 10.1009 23.1491 10.4883 22.7617L21.7066 11.5434M16.7569 6.59367L21.7066 11.5434"
              stroke="#1E3A3A"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      {/* Search bar */}
      <div className="self-stretch px-4 py-2 flex flex-col justify-start items-start gap-2.5">
        <div className="self-stretch p-3 bg-white rounded-md inline-flex justify-start items-center gap-2">
          <div className="size-6 relative overflow-hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M21 21L16.65 16.65M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
                stroke="#6F6F6B"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Tìm kiếm hội nhóm"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="bg-transparent border-none outline-none text-sm w-full text-[#6F6F6B] font-normal font-sora leading-none"
          />
        </div>
      </div>

      {/* Group List */}
      <div className="w-full py-2 flex flex-col justify-start items-center gap-3">
        <div className="self-stretch px-4 inline-flex justify-center items-center gap-2.5">
          <div className="flex-1 justify-start text-[#1E3A3A] text-xl font-semibold font-manrope leading-normal">
            Hội nhóm gần bạn
          </div>
        </div>

        {isLoading ? (
          <div className="text-center py-8">
            <p className="text-[#6F6F6B]">Đang tải hội nhóm...</p>
          </div>
        ) : groups.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-[#6F6F6B]">Không tìm thấy hội nhóm nào</p>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-3 w-full px-4">
            {groups.map((group) => (
              <div
                key={group.id}
                className="w-full max-w-[343px] bg-[#FBF6F1] rounded-lg shadow-[0px_1px_4px_0px_rgba(12,12,13,0.05)] inline-flex justify-start items-start cursor-pointer"
                onClick={() => handleGroupClick(group.id)}
              >
                <img
                  src={group.image}
                  alt={group.name}
                  className="size-28 rounded-tl-lg rounded-bl-lg object-cover"
                />
                <div className="flex-1 self-stretch p-3 inline-flex flex-col justify-between items-start">
                  <div className="flex flex-col justify-start items-start gap-2">
                    <div className="justify-start text-[#1E3A3A] text-base font-medium font-sora leading-tight">
                      {group.name}
                    </div>
                    <div className="inline-flex justify-start items-start gap-2">
                      <div className="flex justify-start items-center gap-1">
                        <div className="size-4 relative overflow-hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M10.6667 4.66667C10.6667 2.8257 9.17428 1.33334 7.33332 1.33334C5.49236 1.33334 4.00001 2.8257 4.00001 4.66667C4.00001 6.50763 5.49236 8 7.33332 8C9.17428 8 10.6667 6.50763 10.6667 4.66667Z"
                              stroke="#6F6F6B"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M2 14.6667C2 11.353 4.38637 8.66669 7.33333 8.66669C10.2803 8.66669 12.6667 11.353 12.6667 14.6667"
                              stroke="#6F6F6B"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14 5.33334C14 3.86057 12.8061 2.66667 11.3333 2.66667"
                              stroke="#6F6F6B"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M14.6667 14.6667C14.6667 11.0545 13.4728 8.66669 11.3333 8.66669"
                              stroke="#6F6F6B"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                          {group.members} thành viên
                        </div>
                      </div>
                      <div className="flex justify-start items-center gap-1">
                        <div className="size-3.5 relative overflow-hidden">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                          >
                            <path
                              d="M11.6668 5.83366C11.6668 8.411 7.00016 12.8337 7.00016 12.8337C7.00016 12.8337 2.3335 8.411 2.3335 5.83366C2.3335 3.25633 4.42283 1.16699 7.00016 1.16699C9.57751 1.16699 11.6668 3.25633 11.6668 5.83366Z"
                              stroke="#6F6F6B"
                            />
                            <path
                              d="M6.99984 6.41667C7.32201 6.41667 7.58317 6.15551 7.58317 5.83333C7.58317 5.51117 7.32201 5.25 6.99984 5.25C6.67766 5.25 6.4165 5.51117 6.4165 5.83333C6.4165 6.15551 6.67766 6.41667 6.99984 6.41667Z"
                              fill="#6F6F6B"
                              stroke="#6F6F6B"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="justify-start text-[#6F6F6B] text-xs font-normal font-sora leading-none">
                          {group.location}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className="px-4 py-2.5 bg-[#215E60] rounded-full inline-flex justify-center items-center gap-2.5"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleJoinToggle(group.id, !!group.joined);
                    }}
                  >
                    <div className="text-center justify-start text-[#F4E7DA] text-sm font-normal font-sora leading-none">
                      {group.joined ? "Đã tham gia" : "Tham gia"}
                    </div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
